import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import { Get_SubjectCategory_ID } from '../../../api/api';
import { useParams, useNavigate } from 'react-router-dom';
import useCategoryList from './../../../hooks/useCategoryList';
import { toast } from 'react-toastify';


const CategoryEdit = () => {

     const CategoryList = useCategoryList()

     const [loading, setLoading] = useState(false)
     const [data, setData] = useState([])

     const params = useParams()
     const navigate = useNavigate()

     const url = Get_SubjectCategory_ID(params.catId)

     useEffect(() => {
          const getCat = async () => {
               try {
                    const res = await axios.get(url)
                    setData(res.data)
               } catch (error) {
                    console.log(error);
               } finally {

               }
          }
          getCat()
     }, []);

     const SubmitHandle = async (e) => {
          e.preventDefault()
          setLoading(true)

          try {
               const res = await axios.put(url, {
                    title: e.target.categoryName.value,
                    parentId: e.target.categoryParent.value > 0 ? e.target.categoryParent.value : null
               });
               toast.success('با موفقیت انجام شد!')
               navigate('/category', { replace: true })
          } catch (error) {
               toast.error('لطفا ورودی های خود را چک کنید')
               console.log(error);
          } finally {
               setLoading(false)
          }
     }


     return (
          <>
               <div className="contentHolder">
                    <div className="row">
                         <div className="col-md-12">
                              <div className="box_radios">
                                   <div className="headHolder bordered"><p className="title">ویرایش دسته بندی</p></div>

                                   <div className="newCategory" style={{ padding: '20px' }}>
                                        <form onSubmit={SubmitHandle}>
                                             <p><input type="text" name="categoryName" id="categoryName" defaultValue={data.title} placeholder="عنوان" /></p>
                                             <p><label style={{ fontSize: '14px' }}>دسته بندی مادر : {' '}
                                                  <select name="categoryParent" id="categoryParent">
                                                       <option value="0">هیچکدام</option>
                                                       {CategoryList && CategoryList.map(cat => (

                                                            cat.title != data.title ? (
                                                                 <option key={cat.id} value={cat.id}>{cat.title}</option>
                                                            ) : ''

                                                       ))}
                                                  </select>
                                             </label></p>

                                             {loading === true ?
                                                  (<p><button type="submit" className="disabled">لطفا صبر کنید...</button></p>)
                                                  :
                                                  (<p><button type="submit">ویرایش دسته بندی</button></p>)
                                             }

                                        </form>
                                   </div>
                              </div>
                         </div>

                    </div>
               </div>
          </>
     )
}
export default CategoryEdit